import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { initialSliceState } from '../constants';
import type { GroupByToApproveTableOptions } from './types';

export const purchaseOrderSlice = createSlice({
  name: 'purchaseOrder',
  initialState: initialSliceState,

  reducers: {
    setSelectedPurchaseOrderId: (
      state,
      action: PayloadAction<{
        purchaseOrderId: number;
      }>,
    ) => {
      const { purchaseOrderId } = action.payload;
      state.selectedPurchaseOrderId = purchaseOrderId;
    },

    setUpdatePurchaseOrderLoading: (state, action: PayloadAction<boolean>) => {
      state.updatePurchaseOrderLoading = action.payload;
    },
    setGroupByToApproveTable: (
      state,
      action: PayloadAction<GroupByToApproveTableOptions>,
    ) => {
      state.groupByToApproveTable = action.payload;
    },
  },
});

const { reducer: sliceReducer, actions } = purchaseOrderSlice;

export const {
  setSelectedPurchaseOrderId,
  setUpdatePurchaseOrderLoading,
  setGroupByToApproveTable,
} = actions;
export { sliceReducer };
